<template>
  <validation-observer ref="formObserver" v-slot="{ passes }">
    <div class="container pb-24 pt-10 md:pt-24 flex justify-center">
      <div class="flex flex-wrap justify-center w-full items-center">
        <div class="md:w-1/3 md:block hidden">
          <img src="/dist/images/logo-seal.jpg" class="max-w-full px-10" alt="AWI Quality Certification Program">
        </div>
        <div class="w-full md:w-2/3 lg:w-1/2">
          <h1 class="bg-green-500 py-3 px-5 text-white text-3xl">
            Please Log In
          </h1>
          <p class="pb-4">
            You must log in first to access the restricted areas of the QCP website.
          </p>
          <p class="pb-10">
            For all Program Participants, use the account information provided to you by QCP staff when you completed the participant application process edited.
          </p>

          <validation-provider v-slot="{ errors }" vid="generic" slim>
            <d-message v-if="errors.length > 0" type="error" class="w-full mb-3">
              {{ errors[0] }}
            </d-message>
          </validation-provider>

          <form ref="form" method="post" action="/account/login" @submit.prevent="passes(submitForm)">
            <input type="hidden" name="ReturnUrl" :value="returnUrl">
            <d-field label="Username" vid="username" rules="required">
              <d-input v-model="form.username" name="username" aria-label="username" required />
            </d-field>
            <d-field label="Password" vid="password" rules="required">
              <d-input v-model="form.password" name="password" aria-label="password" required type="password" />
            </d-field>
            <d-field label=" ">
              <input type="hidden" name="RememberMe" :value="form.rememberMe">
              <d-switch v-model="form.rememberMe">
                Remember Me
              </d-switch>
            </d-field>

            <!-- Mobile Only Login Button Row -->
            <div class="md:flex flex-wrap justify-between items-center pt-5 hidden">
              <a class="w-1/2" href="/forgotpassword/index">Forgot your password?</a>
              <d-btn type="submit" :loading="submitting" class="w-1/3">
                Log In
              </d-btn>
            </div>

            <!-- Tablet/Desktop Only Login Button Row -->
            <div class="flex flex-wrap justify-between items-center pt-5 md:hidden">
              <d-btn type="submit" :loading="submitting" block>
                Log In
              </d-btn>
              <a class="w-full mt-5 text-center" href="/forgotpassword/index">Forgot your password?</a>
            </div>
          </form>
        </div>
      </div>
    </div>
  </validation-observer>
</template>

<script>
  import localforage from 'localforage';

  export default {
    parent: true,

    props: {
      returnUrl: String,

      pageErrors: {
        type: Array,
        default: () => [],
      },
    },

    data: vm => ({
      submitting: false,
      form: {
        username: '',
        password: '',
        rememberMe: false,
        returnUrl: vm.returnUrl,
      },
    }),

    mounted() {
      if (this.pageErrors.length > 0) {
        localforage.setItem('loginEmail', null);
        this.processOnRenderErrors(this.pageErrors, this.form);
      }
      localforage.getItem('loginEmail')
        .then((value) => {
          this.form.username = value;
        });
    },

    methods: {
      submitForm() {
        this.submitting = true;
        localforage.setItem('loginEmail', this.form.username);
        this.$refs.form.submit();
      },
    },
  };
</script>